
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-form",
      function () {
        return require("private-next-pages/contact-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-form"])
      });
    }
  